export const fetchAPI = async <T>(
    endpoint: string,
    method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE",
    body?: Record<string, any>,
    token?: string,
    language?: string,
): Promise<T> => {
    const headers: Record<string, string> = {
        "Content-Type": "application/json",
    };

    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }

    if (language) {
        headers["Accept-Language"] = language;
    }

    try {
        const baseUrl = process.env.REACT_APP_API_BASE_URL;
        if (!baseUrl) {
            throw new Error("REACT_APP_API_BASE_URL environment variable is not defined");
        }

        const fullUrl = `${baseUrl}${endpoint}`;

        const response = await fetch(fullUrl, {
            method,
            headers,
            body: body ? JSON.stringify(body) : undefined,
        });

        if (!response.ok) {
            // Try to parse error message from response body
            let errorData: any = null;
            try {
                const responseText = await response.text();
                if (responseText) {
                    try {
                        errorData = JSON.parse(responseText);
                    } catch (jsonError) {
                        errorData = { message: responseText };
                    }
                }
            } catch (textError) {}

            const errorMessage = errorData?.message || `API request failed with status ${response.status}`;
            const error: any = new Error(errorMessage);
            error.statusCode = response.status;
            error.details = errorData || {};
            error.error = errorData?.error;
            throw error;
        }

        return await response.json();
    } catch (error) {
        console.error("Fetch API error:", error);
        throw error; // Allow calling functions to handle errors properly
    }
};
